import REG from "./regular";
import _ from "lodash";
import i18n from "./i18n"; // 用户名

export function validateUserName(rule, value, callback, fn) {
  if (_.isEmpty(value)) {
    callback(new Error(i18n.t("verify.accountNull")));
  } else if (!REG.validateZh.test(value)) {
    callback(new Error(REG.validateZhMsg));
  } else {
    if (typeof fn == "function") {
      fn();
    } else {
      callback();
    }
  }
} // 密码验证

export function validatePsd(rule, value, callback) {
  if (_.isEmpty(value)) {
    callback(new Error(i18n.t("verify.passwordNull")));
  } else if (!REG.validatePsd.test(value)) {
    callback(new Error(REG.validatePsdMsg));
  }

  callback();
} // 支付密码

export function validatePayPsd(rule, value, callback) {
  if (_.isEmpty(value)) {
    callback(new Error(i18n.t("verify.payPsdNull")));
  } else if (!REG.validatePayPsd.test(value)) {
    callback(new Error(REG.validatePayPsdMsg));
  } else {
    callback();
  }
} // 手机验证

export function validateMobile(rule, value, callback) {
  if (_.isEmpty(value)) {
    callback(); // callback(new Error("手机号码不能为空"));
  } else if (!REG.validateMobile.test(value)) {
    callback(new Error(REG.validateMobileMsg));
  }

  callback();
}
export function validateMobile1(rule, value, callback) {
  if (_.isEmpty(value)) {
    callback(); // callback(new Error("手机号码不能为空"));
  } else if (!REG.validateMobile1.test(value)) {
    callback(new Error(REG.validateMobileMsg));
  }

  callback();
} // 邮箱验证

export function validateEmail(rule, value, callback) {
  if (_.isEmpty(value)) {
    callback(new Error(i18n.t("verify.emailNull")));
  } else if (!REG.validateEmail.test(value)) {
    callback(new Error(REG.validateEmailMsg));
  }

  callback();
} // 时间

export function validateBirthday(rule, value, callback) {
  if (_.isEmpty(value)) {
    callback(new Error(i18n.t("verify.timeNull")));
  } else if (REG.birthday.test(value)) {
    callback(new Error(REG.birthdayMsg));
  }

  callback();
} // 姓名

export function validteRealname(rule, value, callback) {
  if (_.isEmpty(value)) {
    callback(new Error(i18n.t("verify.realnameNull")));
  } else if (REG.realname.test(value)) {
    callback(new Error(REG.realnameMsg));
  }

  callback();
} // 昵称验证

export function validateNickname(rule, value, callback) {
  if (_.isEmpty(value)) {
    callback(new Error(i18n.t("verify.nicknameMsg")));
  } else if (!REG.nickname.test(value)) {
    callback(new Error(REG.nicknameMsg));
  }

  callback();
} // 支付宝

export function validteZFB(rule, value, callback) {
  if (!REG.aliPay.test(value)) {
    callback(new Error(REG.aliPayMsg));
  }

  callback();
} // 微信

export function validteWX(rule, value, callback) {
  if (_.isEmpty(value)) {
    callback(new Error(i18n.t("verify.weChatNull")));
  } else if (!REG.weChat.test(value)) {
    callback(new Error(REG.weChatMsg));
  }

  callback();
} // qq

export function validteQQ(rule, value, callback) {
  if (_.isEmpty(value)) {
    callback(new Error(i18n.t("verify.QQNull")));
  }

  callback();
} // 银行卡号

export function validteBankCardNumber(rule, value, callback) {
  if (_.isEmpty(value)) {
    callback(new Error(i18n.t("verify.bankCardNumberNull")));
  } else if (!REG.bankAccountNumber.test(value)) {
    callback(new Error(REG.BankCardNumberMsg));
  } else {
    callback();
  }
} // 验证码

export function validateCode(rule, value, callback) {
  if (_.isEmpty(value)) {
    callback(new Error(i18n.t("verify.verificationCodeNull")));
  }

  callback();
}